import { Link } from "react-router-dom";
import { ReactNode } from "react";
import { BrandMark } from "@/components/BrandMark";

export default function LegalLayout({ title, updated, children }: { title: string; updated: string; children: ReactNode }) {
  return (
    <div className="min-h-screen bg-gradient-subtle">
      <header className="container mx-auto px-4 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <BrandMark size="sm" />
        </Link>
        <nav className="flex gap-4 text-sm text-muted-foreground">
          <Link to="/terms" className="hover:text-foreground">Terms</Link>
          <Link to="/refund-policy" className="hover:text-foreground">Refunds</Link>
          <Link to="/privacy" className="hover:text-foreground">Privacy</Link>
        </nav>
      </header>
      <main className="container mx-auto px-4 pb-24 max-w-3xl">
        <h1 className="text-4xl font-bold mb-2">{title}</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: {updated}</p>
        <article className="prose prose-slate max-w-none space-y-4 text-sm leading-relaxed [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-8 [&_h2]:mb-2 [&_h3]:font-semibold [&_h3]:mt-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_a]:text-primary [&_a]:underline">
          {children}
        </article>
      </main>
    </div>
  );
}
